import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import ClientList from "./ClientList";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("client-list")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<ClientList />
		</ThemeProvider>
	</StrictMode>
);
